<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="campaignName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="campaignCreator">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'campaignEmailSubject'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'campaignStatus'">
                <wbo-single-select-search-control initialDefaultValue="All">
                    <wbo-select-options>
                        <wbo-select-option value="All" label="wbo.marketing-campaign.option.status.all">
                        </wbo-select-option>
                        <wbo-select-option value="Draft" label="wbo.marketing-campaign.option.status.draft">
                        </wbo-select-option>
                        <wbo-select-option value="Scheduled" label="wbo.marketing-campaign.option.status.scheduled">
                        </wbo-select-option>
                        <wbo-select-option value="Sending" label="wbo.marketing-campaign.option.status.sending">
                        </wbo-select-option>
                        <wbo-select-option value="Sent" label="wbo.marketing-campaign.option.status.sent">
                        </wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'campaignMessageType'">
                <wbo-single-select-search-control initialDefaultValue="All" [allowClearSelectionOption]="false">
                    <wbo-select-options>
                        <wbo-select-option value="All" label="wbo.marketing-campaign.option.campaign-type.all">
                        </wbo-select-option>
                        <wbo-select-option value="Email" label="wbo.marketing-campaign.option.campaign-type.email">
                        </wbo-select-option>
                        <wbo-select-option value="SMS" label="wbo.marketing-campaign.option.campaign-type.sms">
                        </wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-column field="campaignName"></wbo-column>
        <wbo-column field="campaignCreator"></wbo-column>
        <wbo-column field="campaignMessageType"></wbo-column>
        <wbo-column field="campaignStatus"></wbo-column>
        <wbo-date-column field="createdDate"></wbo-date-column>
        <wbo-actions-search-column>
            <wbo-delete-search-action></wbo-delete-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>

